exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-66ea6dd6] .el-table__body tr.hover-row>td{background-color:#eaecfc !important}", ""]);

// exports
